import React, { useEffect, useState } from 'react';
import './index.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveQuestion } from '../../redux/actions/questionActions';
import { QUESTION_PATH } from '../../routes/path';

const NewQuestion = () => {
  const [question, setQuestion] = useState('');
  const [isQuestionValid, setIsQuestionValid] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { saveStatus } = useSelector((state) => state.questionReducer);

  const handleQuestionChange = (event) => {
    const newQuestion = event.target.value;
    setQuestion(newQuestion);
    setIsQuestionValid(newQuestion.length >= 5);
  };

  const redirect = () => {
    navigate(`${QUESTION_PATH}`);
  };

  useEffect(() => {
    if (saveStatus) redirect();
  }, [saveStatus]);

  const handleSubmit = (event) => {
    event.preventDefault();
    dispatch(saveQuestion(question));
    setQuestion('');
  };

  return (
    <div className="newquestion-container">
      <div className="newitems-container">
        <h3>Nueva pregunta</h3>
        <h4>Pregunta</h4>
        <form onSubmit={handleSubmit}>
          <textarea className={`input-container ${isQuestionValid ? 'valid' : 'invalid'}`} type="text" maxLength="500" value={question} onChange={handleQuestionChange} />
          <p>500 caracteres max</p>
          <button disabled={!isQuestionValid} className="newbutton-turn-confirm">Enviar pregunta</button>
        </form>
      </div>
    </div>
  );
};

export default NewQuestion;
